"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceTreePicker = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _useFetchManagementGroups = _interopRequireDefault(require("./hooks/useFetchManagementGroups"));
var _ServiceTreeSelector = _interopRequireDefault(require("./ServiceTreeSelector"));
var _TagInput = require("./TagInput");
var _useTreePickerVisibility = _interopRequireDefault(require("./hooks/useTreePickerVisibility"));
var _selectedProductsReducer = _interopRequireDefault(require("./hooks/selectedProductsReducer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var ServiceTreePicker = function ServiceTreePicker(props) {
  var disabled = props.disabled,
    defaultProducts = props.defaultProducts,
    onChange = props.onChange;
  var TagInput = React.useMemo(_TagInput.newTagInput, []);
  var _useTreePickerVisibil = (0, _useTreePickerVisibility.default)(disabled),
    showTreePicker = _useTreePickerVisibil.showTreePicker,
    focusedElementsDispatch = _useTreePickerVisibil.focusedElementsDispatch,
    parentRef = _useTreePickerVisibil.parentRef;
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchQuery = _React$useState2[0],
    setSearchQuery = _React$useState2[1];
  var _useFetchManagementGr = (0, _useFetchManagementGroups.default)(disabled),
    managementGroups = _useFetchManagementGr.managementGroups,
    managementGroupIsLoading = _useFetchManagementGr.managementGroupIsLoading,
    managementGroupParentMap = _useFetchManagementGr.managementGroupParentMap;
  var _React$useReducer = React.useReducer(_selectedProductsReducer.default, []),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    selectedProducts = _React$useReducer2[0],
    selectedProductsDispatch = _React$useReducer2[1];
  var tagInputRef = React.useRef(null);
  var treeRef = React.useRef(null);
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    treeFocusedIndex = _React$useState4[0],
    setTreeFocusedIndex = _React$useState4[1];
  var onSelect = React.useCallback(function () {
    var _tagInputRef$current, _tagInputRef$current2;
    (_tagInputRef$current = tagInputRef.current) === null || _tagInputRef$current === void 0 ? void 0 : _tagInputRef$current.clearInput();
    (_tagInputRef$current2 = tagInputRef.current) === null || _tagInputRef$current2 === void 0 ? void 0 : _tagInputRef$current2.focusInput();
    focusedElementsDispatch({
      type: "clear"
    });
  }, [focusedElementsDispatch]);
  React.useEffect(function () {
    selectedProductsDispatch({
      type: "set",
      payload: defaultProducts.map(function (x) {
        return {
          key: x.id,
          name: x.name
        };
      })
    });
  }, [defaultProducts]);
  React.useEffect(function () {
    onChange(selectedProducts, selectedProducts.length > 0);
  }, [onChange, selectedProducts]);
  var onResolveSuggestions = React.useCallback(function (filter) {
    setSearchQuery(filter);

    // Return nothing since the native suggestions renderer from the <TagPicker/>
    // is not used (so it doesn't matter what we return)
    return [];
  }, []);
  var onServiceTreeKeyDown = React.useCallback(function (e) {
    if (!showTreePicker) {
      return;
    }
    if (e.keyCode === _react2.KeyCodes.escape) {
      var _tagInputRef$current3;
      (_tagInputRef$current3 = tagInputRef.current) === null || _tagInputRef$current3 === void 0 ? void 0 : _tagInputRef$current3.onEscape(e);
      focusedElementsDispatch({
        type: "clear"
      });
    } else if (e.keyCode === _react2.KeyCodes.up || e.keyCode === _react2.KeyCodes.down) {
      if (e.keyCode === _react2.KeyCodes.up && treeFocusedIndex === 0) {
        var _tagInputRef$current4;
        (_tagInputRef$current4 = tagInputRef.current) === null || _tagInputRef$current4 === void 0 ? void 0 : _tagInputRef$current4.focusInput();
      }
      if (treeRef.current) {
        setTreeFocusedIndex(treeRef.current.getFocusIndex());
      }
    }
  }, [focusedElementsDispatch, showTreePicker, treeFocusedIndex]);
  return /*#__PURE__*/React.createElement("div", {
    ref: parentRef
  }, /*#__PURE__*/React.createElement(TagInput, {
    componentRef: tagInputRef,
    focusedElementsDispatch: focusedElementsDispatch,
    selectedItems: selectedProducts,
    disabled: disabled,
    "aria-label": t("repositoryOwnerPanel.assign.service.title"),
    inputProps: {
      "aria-label": t("repositoryOwnerPanel.assign.service.ariaInput"),
      id: "services-search",
      onClick: function onClick() {
        focusedElementsDispatch({
          type: "add",
          payload: "tagInput"
        });
      },
      onFocus: function onFocus() {
        focusedElementsDispatch({
          type: "add",
          payload: "tagInput"
        });
      },
      placeholder: selectedProducts.length === 0 ? t("repositoryOwnerPanel.assign.service.searchHelpText") : ""
    },
    onChange: function onChange(p) {
      // This onChange handler is used to handle only deletion operation.
      // The only other operation, addition, is not handled here because the native dropdown picker is replaced by the custom tree picker.
      // Hence, the addition is handled in the custom tree picker, inside <ServiceTreeSelector/>.
      selectedProductsDispatch({
        type: "set",
        payload: p !== null && p !== void 0 ? p : []
      });
    },
    onResolveSuggestions: onResolveSuggestions,
    removeButtonAriaLabel: "Remove",
    renderDialog: function renderDialog() {
      return /*#__PURE__*/React.createElement("div", {
        role: "dialog",
        id: "service-tree-picker-dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "st-selector-wrapper depth-8",
        onBlur: function onBlur(e) {
          if (e.relatedTarget !== null) {
            focusedElementsDispatch({
              type: "delete",
              payload: "tree"
            });
          }
          setTreeFocusedIndex(undefined);
        },
        onFocus: function onFocus() {
          focusedElementsDispatch({
            type: "add",
            payload: "tree"
          });
          setTreeFocusedIndex(0);
        },
        onKeyDown: onServiceTreeKeyDown,
        role: "presentation",
        style: {
          display: showTreePicker ? "block" : "none"
        }
      }, /*#__PURE__*/React.createElement(_ServiceTreeSelector.default, {
        isLoading: managementGroupIsLoading,
        managementGroups: managementGroups,
        managementGroupParentMap: managementGroupParentMap,
        onSelect: onSelect,
        searchQuery: searchQuery,
        selectedProductsDispatch: selectedProductsDispatch,
        treeRef: treeRef
      })));
    },
    resolveDelay: 250,
    showPicker: showTreePicker
  }));
};
exports.ServiceTreePicker = ServiceTreePicker;